import { useEffect, useState, type FC } from "react";
import CurrencyInput from "react-currency-input-field";
import { Button, Modal, SelectPicker } from "rsuite";
import { Brand, TopBrand } from "../../../models/inventory/brand";
import { getBrands } from "../../../services/inventory/BrandApi";

interface TopBrandFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: TopBrand) => void;
  topBrand?: TopBrand;
}

const TopBrandForm: FC<TopBrandFormProps> = ({
  open,
  onClose,
  onSubmit,
  topBrand,
}) => {
  const [brands, setBrands] = useState<Brand[]>([]);

  const [data, setData] = useState<TopBrand>({
    id: "",
    brand_id: "",
    value: 0,
  });

  const getAllBrands = async (search: string) => {
    getBrands({
      page: 1,
      size: 10,
      search,
    })
      .then((v) => v.json())
      .then((v) => setBrands(v.data.items));
  };

  useEffect(() => {
    setData(
      topBrand || {
        id: "",
        brand_id: "",
        value: 0,
      }
    );
    getAllBrands("");
  }, [topBrand]);

  return (
    <Modal size={"lg"} open={open} onClose={onClose}>
      <Modal.Header>
        <Modal.Title>Top Brand</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="w-full">
          <div className="form-group">
            <label>Brand</label>
            <div className="input">
              {topBrand?.id ? (
                <div>{topBrand?.brand?.name}</div>
              ) : (
                <SelectPicker
                  block
                  data={brands}
                  labelKey="name"
                  valueKey="id"
                  value={data.brand_id}
                  onChange={(value) => {
                    setData({ ...data, brand_id: value! });
                  }}
                />
              )}
            </div>
          </div>
          <div className="form-group">
            <label>Value</label>
            <CurrencyInput
              className="rs-input"
              value={data.value}
              groupSeparator="."
              decimalSeparator=","
              onValueChange={(value, name, values) =>
                setData({ ...data, value: values?.float ?? 0 })
              }
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="pt-4">
          <Button
            appearance="primary"
            onClick={() => {
              onSubmit(data!);
              setData({
                id: "",
                brand_id: "",
                value: 0,
              });
            }}
          >
            Submit
          </Button>
          <Button appearance="link" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default TopBrandForm;
